import './request_details.less'
import React, {PropTypes} from 'react';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../../auth/auth_actions';
import requestAnItemActions from '../request_an_item_actions';
import PriceAdjustment from '../../components/price_adjustment/price_adjustment';
import validate from '../../util/validate';
import {toTitleCase,join,localTimestampToGMT,GMTTimeStampToLocal} from '../../util/common';
import ShowError from '../../components/error/show_error';
import InputComponent from '../../components/input_component/input_component';
import LocationInput from '../../components/location_auto_search/location_auto_search'
import fileUploadActions from '../../image_upload/file_upload_actions';
import CONSTANTS from '../../common_constants';
import {Link, browserHistory} from 'react-router';
import $ from 'jquery';
import LoggedinFooter from '../../footer/loggedin_footer';
import shipmentActions from '../../shipment/shipment_actions';
import moment from 'moment';

class UploadImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUrl : props.initialImgUrl
    }
  }
  uploadImage = () =>{
    $('input[type=file]').trigger('click');
  }
  componentWillReceiveProps(newProps){
    this.setState({
        imageUrl : newProps.initialImgUrl
    })
  }
  getFileObject = () =>{
    let imageUrl = null;
    const self  = this;
    // here the function should return the image object
    let file = this.refs.imageUpload.files[0];
    this.setState({
      isLoading: true
    })
    fileUploadActions.shipmentImageUpload(file).then((successData)=> {
      if(successData){
        imageUrl = successData.successMessage;
      }
      this.setState({
        isLoading: false,
        imageUrl
      })
      self.props.getImgUrl(imageUrl)
    }, (error)=>{
      this.setState({
        isLoading: false
      })
      console.log("error" + error);
    })
  }
  render() {
    const {imageUrl} = this.state;
    return (
      <div className = "upload-image-wrap">
        {this.state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        {
          imageUrl && <div className = "uploaded-img"style={{"backgroundImage": 'url("' + imageUrl + '")'}} ></div>
        }
        {
          !imageUrl && <div className ="image-upload-section">
          <span className="icon-group img-upload" onClick={this.uploadImage}><span className="path1"></span><span className="path2"></span></span>
          <input className="displayNone" type="file" accept="image/*" ref="imageUpload" onChange={this.getFileObject} />
          </div>
        }
    </div>
    )
  }
}
class RequestDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      requestAnItem : props.requestAnItem,
      error: null,
      ajaxInProgress:false
    }
    window.scrollTo(0,0);
  }
  componentDidMount(){
    const self = this;
    const {props} = this;
    const {shipmentActions} = this.props;
    const shipmentId = props.location.query.shipmentId;
    this.setState({
      shipmentId
    })
    if(shipmentId && !("title" in props.requestAnItem))
    {
      this.setState({isLoading: true});
      shipmentActions.clearShipmentDetails();
      shipmentActions.getShipmentDetails(shipmentId).then((data) => {
        self.setState({isLoading: false, error: ''});
        self.storeShipmentDetails(data)
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        self.setState({isLoading: false, error: errorRes.error})
      });
    }
  }
  storeShipmentDetails = (shipment) =>{
    this.props.requestAnItemActions.clearRequestDetails();
      let shipmentDetails = {
        title : shipment.title,
        shipmentId : shipment.shipmentId,
        shipmentCost : shipment.shipmentCost,
        itemValue : shipment.itemValue,
        description : shipment.description,
        imageIds: shipment.imageUrlList,
        pickupLat : shipment.pickupLat,
        pickupLong : shipment.pickupLong,
        pickupLocation : shipment.pickupLocation,
        pickupCountry : shipment.pickupCountry,
        pickupCity : shipment.pickupCity,
        pickupLandmark : shipment.pickupLandmark,
        deliveryLat : shipment.deliveryLat ,
        deliveryLong : shipment.deliveryLong ,
        deliveryLocation : shipment.deliveryLocation ,
        deliveryCountry : shipment.deliveryCountry ,
        deliveryCity : shipment.deliveryCity ,
        deliveryLandmark : shipment.deliveryLandmark,
        notes : shipment.notes,
        isIWillMeetCarrierAtDelivery : ((shipment.isIWillMeetCarrierAtDelivery != null) ? shipment.isIWillMeetCarrierAtDelivery :true ),
        deliveryDate : moment().startOf('day').unix() *1000 + ((8*24*60*60*1000) - 60000),
        deliveryUser : shipment.deliveryUser || {}
      }
      this.props.requestAnItemActions.storeReqeustDetails(shipmentDetails);
      this.setState({
        requestAnItem : this.props.requestAnItem
      })
  }
  goBack = () =>{
    browserHistory.push('/request-an-item');
  }
  changeHandler = (type , value) =>{
      let requestAnItem = Object.assign({} , this.state.requestAnItem);

      const {userData} = this.props.authState;
      if(userData.email) amplitude.getInstance().setUserId(userData.email);
      amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.REQ_ITEM_DETAILS_START);

      if(type == 'location')
      {
        if(value)
        {
          requestAnItem.pickupLat = value.location.lat;
          requestAnItem.pickupLong = value.location.lng;
          requestAnItem.pickupLocation = value.label ;
          requestAnItem.pickupCountry = value.country;
          requestAnItem.pickupCountryCode = value.countryCode;
          requestAnItem.pickupCity = value.cityName;
          requestAnItem.pickupLandmark = value.landMark;

          if(userData.email) amplitude.getInstance().setUserId(userData.email);
          amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.REQ_ITEM_LOCATION,{locationName:value.label});

        }else{
          requestAnItem.pickupLat = null;
          requestAnItem.pickupLong = null;
          requestAnItem.pickupLocation = null;
          requestAnItem.pickupCountry = null;
          requestAnItem.pickupCountryCode = null;
          requestAnItem.pickupCity = null;
          requestAnItem.pickupLandmark = null;
        }
          this.setState({
              requestAnItem
          })
      }else{
        requestAnItem[type] = value;
        if(type == 'itemValue')
        {
          requestAnItem['shipmentCost'] = Math.round(((value * 0.1) > 20 ? (value * 0.1) : 20).toFixed(1));
          requestAnItem[type] = Math.round(value);
        }
        this.setState({
            requestAnItem
        })
      }
  }
  getImageUrl = (URL) =>{
    let requestAnItem = Object.assign({} , this.state.requestAnItem);
    requestAnItem.imageIds = [];
    requestAnItem.imageIds.push(URL)
    requestAnItem.thumbnailImage = URL
    this.setState({
      requestAnItem
    })
  }
  submit = (e) =>{
    e.preventDefault();
    this.setState({error:null});
    const self = this;
    const validationError = {
        title: !validate.name(this.state.requestAnItem.title),
        description: !validate.name(this.state.requestAnItem.description),
        location: !validate.name(this.state.requestAnItem.pickupLocation),
        itemValue: !validate.numeric(this.state.requestAnItem.itemValue)
    };
    const validationMap = {
        title: 'Title',
        description: 'Description',
        location: 'Location',
        itemValue : 'Iteam Value'
    };
    let errorMsg = "";
    const validationFields = [];
    Object.keys(validationError).forEach((key) => {
        if (validationError[key])
            validationFields.push(validationMap[key]);
        }
    );
    if (validationFields.length) {
        errorMsg = 'Please enter valid ' + join(validationFields, (item, idx) => {
            if (validationFields.length === 1)
                return "";
            if (idx > 0 && idx < validationFields.length - 1)
                return ", ";
            else if (idx === validationFields.length - 1)
                return " and ";
            return "";
        }) + '.';
    }
    if(errorMsg){
       $("html, body").animate({scrollTop: 0}, 1000);
      this.setState({
        error : errorMsg,
        validationError : validationError
      });
      return;
    }

    const {userData} = this.props.authState;
    if(userData.email) amplitude.getInstance().setUserId(userData.email);
    amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.REQ_ITEM_DETAILS_NEXT);

    this.props.requestAnItemActions.storeReqeustDetails(this.state.requestAnItem);
    if(this.state.shipmentId)
      browserHistory.push('/request-an-item/delivery-details?shipmentId='+ this.state.shipmentId);
    else
      browserHistory.push('/request-an-item/delivery-details');
  }
  saveAsDraft = (e) =>{
    e.preventDefault();
    $("html, body").animate({scrollTop: 0}, 1000);
    this.setState({error:null});
    const validationError = {
        title: !validate.name(this.state.requestAnItem.title)
    };
    const validationMap = {
        title: 'Title'
    };
    let errorMsg = "";
    const validationFields = [];
    Object.keys(validationError).forEach((key) => {
        if (validationError[key])
            validationFields.push(validationMap[key]);
        }
    );
    if (validationFields.length) {
        errorMsg = 'Please enter valid ' + join(validationFields, (item, idx) => {
            if (validationFields.length === 1)
                return "";
            if (idx > 0 && idx < validationFields.length - 1)
                return ", ";
            else if (idx === validationFields.length - 1)
                return " and ";
            return "";
        }) + '.';
    }
    if(errorMsg){
      this.setState({
        error : errorMsg,
        validationError : validationError
      });
      return;
    }
    let parameters = Object.assign({} , this.state.requestAnItem);
    parameters.shipmentStatus = 1;
    parameters.shipmentType = 2 ; //request an item
    this.setState({
      ajaxInProgress : true
    })
    let API = "CREATE";
    if(this.state.shipmentId)
      API = "UPDATE"
    this.props.requestAnItemActions.createAshipment(parameters,API).then(() => {
        this.setState({ajaxInProgress: false});
        browserHistory.push('/dashboard');
    }, (errorRes) => {
        if(errorRes.error === CONSTANTS.sessionInvalid){
          this.setState({ajaxInProgress: false})
          this.props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        this.setState({ajaxInProgress: false,successMsg:""});
    })
  }
  render() {
    const {requestAnItem} = this.state;
    let basePriceDecimal = ((requestAnItem.itemValue * 0.1) > 20 ? (requestAnItem.itemValue * 0.1) : 20 ).toFixed(1)
    let basePrice = Math.round(basePriceDecimal)
    let increasePriceDecimal = 0 , increasePrice = 0;
    if(requestAnItem.shipmentCost)
       increasePriceDecimal =  (requestAnItem.shipmentCost - basePrice) < 0 ? 0 :(requestAnItem.shipmentCost - basePrice).toFixed(1) ;
    increasePrice = parseInt(increasePriceDecimal)
    const loader = <div className="loader-button"></div>;
    let img = (requestAnItem ? (requestAnItem.imageIds ? requestAnItem.imageIds[0]: null) : null)
    return (
      <div id="requestAnItemRequestDetailsWrap">
        <div className = "wrapper request-an-item-request-details-wrap">
          {this.state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
          <div className = "request-an-item-request-details">
            <div className ="error-section">
              {this.state.error && <ShowError errorMessage = {this.state.error} />}
            </div>
            <div className = "heading">
                Enter Request Details
            </div>
            <div className ="input-details-wrap">
              <div className = "input-details">
                <InputComponent type="text" dollar ={false}value = {requestAnItem.title} title = "Title" placeholder = "Item name" for ="title" changeHandler = {this.changeHandler}/>
              </div>
              <div className = "input-details">
                <InputComponent type="text" dollar ={false}value = {requestAnItem.description} title = "Description" placeholder = "Details, specifications, etc." for ="description" changeHandler = {this.changeHandler}/>
              </div>
              <div className = "input-details">
                <LocationInput value = {requestAnItem.pickupLocation}title = "Location" placeholder ="Where to find it" for ="location" changeHandler = {this.changeHandler}/>
              </div>
              <div className = "input-details">
                <UploadImage initialImgUrl = {img} getImgUrl = {this.getImageUrl}/>
              </div>
              <div className = "input-details">
                <InputComponent type="number" dollar ={true}value = {requestAnItem.itemValue} title = "Item value" placeholder = "Market value of your package" for ="itemValue" changeHandler = {this.changeHandler}/>
              </div>
            </div>
            <div className ="shipment-cost-section">
              <div className = "shipment-cost-title">
                Shipment cost
              </div>
              <div className="price-section-wrap">
                <div className = "price-section">
                  <div className = "title">
                    Recommended base price
                  </div>
                  <div className = "amount disabled">
                    ${basePrice}
                  </div>
                </div>
                <div className = "price-section amt">
                  <div className = "title">
                    Your price increase
                  </div>
                  <div className = "amount green">
                    + {increasePrice || 0  }
                  </div>
                </div>
              </div>
              {
                requestAnItem.itemValue != null && <div className = "price-adjustment-section">
                  <PriceAdjustment changeHandler = {this.changeHandler} minPrice ={basePrice}  price = {requestAnItem.shipmentCost} for = "shipmentCost"/>
                </div>
              }
            </div>
            <div className ="instruction">
              Shipment cost is based off of the market value, package size, and distance.
            </div>
            <div className = "submit-section">
              <div className = "submit-options">
                  <button className = "btn orange" onClick = {this.submit} >Next</button>
              </div>
              <div className = "submit-options m-l">
                  <button className = "btn green" onClick = {this.saveAsDraft} >{this.state.ajaxInProgress? loader : 'Save and Exit'}</button>
              </div>
            </div>
          </div>
        </div>
        <LoggedinFooter />
      </div>
    )
  }
}


RequestDetails = connect((state) => {
  return {
    requestAnItem : state.app.requestAnItem,
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch),
    requestAnItemActions :bindActionCreators(requestAnItemActions, dispatch),
    shipmentActions: bindActionCreators(shipmentActions, dispatch)
  }
})(RequestDetails);

export default RequestDetails;



// WEBPACK FOOTER //
// app/request_an_item/request_details/request_details.jsx